import moment from 'moment/moment'
import store from '@/vuex/store'

function getOffsetMoment (unixtime) {
  if (!unixtime) return '--'
  const offset = store.getters.login.profile.timezone_offset
  const locale = store.getters.login.profile.language
  return moment.unix(unixtime).locale(locale).utcOffset(offset)
}

function strIns (str, idx, val) {
  const res = str.slice(0, idx) + val + str.slice(idx)
  return res
}

// グローバルフィルター
export function YMD (unixtime) {
  return getOffsetMoment(unixtime).format('L')
}

export function YMDT (unixtime) {
  return getOffsetMoment(unixtime).format('L') + ' ' + getOffsetMoment(unixtime).format('LT')
}

export function number (value) {
  // 1234567 → 1,234,567
  if (value) {
    return value.toLocaleString()
  } else {
    return value
  }
}

export function calendar (unixtime) {
  try {
    const offset = store.getters.login.profile.timezone_offset
    const m = moment.unix(unixtime).locale('en').utcOffset(offset).calendar()
    if (m.match(/Yesterday|Today|Tomorrow/)) {
      return getOffsetMoment(unixtime).calendar()
    } else {
      return YMDT(unixtime)
    }
  } catch (error) {
    return unixtime
  }
}

export function japanesePostalCode (code) {
  return strIns(code, 3, '-')
}


/**
 * remove unused services from response data
 * @param {Array} data response data
 * @return {Array} filtered data
 */
export function removeUnusedServices (data) {
  if (!Array.isArray(data)) return data

  const unusedServices = ['datacenter', 'vcr_rudder_manage_portal', 'vcr_rudder_maker_portal']
  return data.filter((item) => !unusedServices.includes(item.id))
}
